<template>
  <div class="ml-2 mr-2">
    <!-- Change component name -->

    <h4 class="text-center mt-3">Nombre</h4>
    <v-text-field
      class="ml-2 mr-2"
      v-model="selectedItem.component_name"
      single-line
      clearable
      @keyup.enter="updateEditing(false)"
      :clear-icon-cb="selectedItem.component_name == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
      @blur="updateEditing(false)"
    />

    <!-- Change component from square to round -->
    <v-checkbox
      color="info"
      hide-details
      class="option"
      v-model="selectedItem.customized.round"
      label="Formato circular"
    >
    </v-checkbox>
    <!-- Add border to the nav -->
    <v-checkbox
      v-if="selectedItem.customized.nav_type == 'Texto'"
      color="info"
      hide-details
      class="option"
      v-model="selectedItem.customized.border"
      label="Añadir borde"
    >
    </v-checkbox>
    <!-- Change border width -->
    <h4
      v-if="selectedItem.customized.border"
      class="text-center mt-3"
    >
      Grosor del borde
    </h4>
    <v-slider
      v-if="selectedItem.customized.border"
      v-model="selectedItem.customized.border_width"
      :min="1"
      :max="10"
      :step="1"
      thumb-label
      thumb-color="black"
    ></v-slider>
    <h4
      v-if="selectedItem.customized.border"
      class="text-center mt-3"
    >
      Color del borde
    </h4>

    <!-- Select border color -->
    <koiote-color-picker-vue
      v-if="selectedItem.customized.border"
      :pcolor="selectedItem.customized.border_color"
      @event="change_border_color"
      class="mt-2"
    ></koiote-color-picker-vue>

    <!-- Select where is going to redirect the nav component -->
    <h4 class="text-center mt-6">Destino</h4>
    <v-select
      v-model="next"
      :items="activePages"
      item-text="name"
      return-object
      :label="Object.keys(next).length > 0 ? next.name : 'Seleccionar'"
      solo
      class="mt-4"
    ></v-select>

    <h4 class="text-center mt-6">Redireccion</h4>
    <v-text-field
      class="ml-2 mr-2"
      v-model="selectedItem.customized.redirect"
      single-line
      clearable
      :clear-icon-cb="selectedItem.component_name == null ? updateEditing(true) : null"
      @click="updateEditing(true)"
    />

    <!-- Select text or icon navigation -->
    <h4 class="text-center mt-3">Tipo</h4>
    <v-radio-group v-model="selectedItem.customized.nav_type">
      <v-radio
        v-for="(item, index) in ['Texto', 'Icono', 'Imagen']"
        :key="index"
        :label="item"
        :value="item"
        color="info"
      ></v-radio>
    </v-radio-group>

    <!-- texto -->
    <div v-if="selectedItem.customized.nav_type == 'Texto'">
      <h4 class="text-center mt-3">Texto</h4>
      <v-text-field
        class="ml-2 mr-2"
        v-model="selectedItem.customized.nav_text"
        single-line
        clearable
        @keyup.enter="updateEditing(false)"
        :clear-icon-cb="selectedItem.customized.nav_text == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
        @blur="updateEditing(false)"
      />

      <h4
        v-if="selectedItem.customized.border"
        class="text-center mt-3"
      >
        Background color
      </h4>

      <koiote-color-picker-vue
        :pcolor="selectedItem.customized.background_color"
        @event="change_background_color"
        class="mt-2"
      ></koiote-color-picker-vue>

      <h4
        v-if="selectedItem.customized.border"
        class="text-center mt-8"
      >
        Foreground color
      </h4>

      <koiote-color-picker-vue
        :pcolor="selectedItem.customized.foreground_color"
        @event="change_foreground_color"
        class="mt-2"
      ></koiote-color-picker-vue>
    </div>

    <!-- Icono -->
    <div v-else-if="selectedItem.customized.nav_type == 'Icono'">
      <h4 class="text-center mt-3">Icono</h4>
      <select-icon></select-icon>
    </div>

    <!-- Imagen -->
    <div v-else-if="selectedItem.customized.nav_type == 'Imagen'">
      <h4 class="text-center mt-3">Imagen</h4>
      <v-file-input
        accept="image/*"
        label="Imagen"
        dense
        background-color="white"
        ref="refFileInput"
        @change="fileChangedInItem"
      ></v-file-input>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import KoioteColorPickerVue from "@/components/utils/KoioteColorPicker.vue";
import SelectIcon from "@/plugins/navigation/SelectIcon.vue";

export default {
  name: "KoioteNavigationProperties",

  components: {
    KoioteColorPickerVue,
    SelectIcon,
  },

  data() {
    return {
      next: {},
      file: null,
    };
  },

  computed: {
    ...mapGetters(["activePages"]),
    ...mapState(["selectedItem"]),
  },

  methods: {
    ...mapActions(["updateEditing"]),

    change_background_color(nc) {
      this.selectedItem.customized.background_color = nc;
    },

    change_foreground_color(nc) {
      this.selectedItem.customized.foreground_color = nc;
    },

    change_border_color(nc) {
      this.selectedItem.customized.border_color = nc;
    },

    fileChangedInItem(e) {
      if (e != null) {
        const reader = new FileReader();
        reader.onload = (event) => {
          //si ya existe imagen para ese valor, la reemplaza
          this.selectedItem.customized.image = event.target.result;
        };
        reader.readAsDataURL(e);
      } else {
        // si se borra la imagen
        this.selectedItem.customized.image = null;
      }
    },
  },

  mounted() {
    if (this.selectedItem.customized.next_page != "") {
      this.next = this.activePages.find((e) => e._id == this.selectedItem.customized.next_page);
    }
  },

  watch: {
    next() {
      if (Object.keys(this.next).length > 0 && this.next._id != this.selectedItem.customized.next_page) {
        this.selectedItem.customized.next_page = this.next._id;
      }
    },
  },
};
</script>

<style>
.option {
  margin-top: 15%;
  margin-bottom: 15%;
}
</style>
